import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { SalesStageTable } from 'features/settings/components/SalesStageTable'
import { DistributorTable } from 'features/settings/components/DistributorTable'
import { GPOTable } from 'features/settings/components/GPOTable'

const DEFAULT_TAB = 'sales-stages'

const tabs = [
  { key: 'sales-stages', title: 'Sales Stages' },
  { key: 'distributors', title: 'Distributors' },
  { key: 'gpos', title: 'GPOs' },
]

const validTabs = new Set(tabs.map((t) => t.key))

export function PlatformSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = params.tab ?? DEFAULT_TAB

  if (params.tab && !validTabs.has(params.tab)) {
    return <Navigate to={`/settings/platform/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/platform/${value}`)}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'sales-stages'}>
        <SalesStageTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'distributors'}>
        <DistributorTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'gpos'}>
        <GPOTable />
      </FBPageTableContainer>
    </div>
  )
}
